import React from 'react';
import { XCircle } from 'lucide-react';
import { cn } from '../../../lib/utils';

export interface TaskyErrorStateProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
}

export const TaskyErrorState: React.FC<TaskyErrorStateProps> = ({
  className,
  title = 'エラーが発生しました',
  description,
  action,
  ...rest
}) => (
  <div
    role="alert"
    {...rest}
    className={cn(
      'bg-destructive/10 rounded-tasky-md p-4 flex items-start gap-3',
      className,
    )}
  >
    <XCircle className="w-5 h-5 text-destructive shrink-0 mt-0.5" />
    <div className="flex-1 min-w-0">
      <p className="text-sm font-semibold text-dark">{title}</p>
      {description && <p className="text-sm text-dark/70 mt-0.5">{description}</p>}
    </div>
    {action && <div className="shrink-0">{action}</div>}
  </div>
);
